//префикс апи 
export const API_BASE_URL = '/api/v1/'
export const prefixAPI = (url) => API_BASE_URL + url





// WEBPACK FOOTER //
// ./src/js/resource/api.js